import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const brandValues = [
  {
    icon: 'ri-medal-line',
    title: '内容品质',
    description: '专业编辑团队层层筛选，每一部视频都经过严格的内容审核和品质把控，确保为用户提供真正有价值的视听内容。',
  },
  {
    icon: 'ri-team-line',
    title: '创作者生态',
    description: '与3200多位优质创作者建立合作关系，为创作者提供公平的收益分成和完善的创作支持体系。',
  },
  {
    icon: 'ri-lightbulb-line',
    title: '技术创新',
    description: '持续投入技术研发，通过智能推荐算法和先进的视频编码技术，为用户提供流畅、个性化的观看体验。',
  },
];

const milestones = [
  { year: '2020', event: '精品视频平台正式上线，初始内容库1000+部精品视频' },
  { year: '2021', event: '完成A轮融资，创作者合作伙伴突破500位，月活用户突破100万' },
  { year: '2022', event: '推出原创内容计划，上线AI智能推荐系统，用户留存率提升40%' },
  { year: '2023', event: '内容总量突破20000部，覆盖8大领域，推出多端同步观看功能' },
  { year: '2024', event: '获得年度最佳视频平台奖，创作者合作伙伴突破2000位' },
  { year: '2025', event: '用户数突破5000万，推出离线观看和4K超高清内容，日均访客超100万' },
  { year: '2026', event: '全面升级内容生态体系，创作者超3200位，精品视频超50000部，持续引领行业发展' },
];

const testimonials = [
  {
    name: '张先生',
    role: '教育行业从业者',
    content: '精品视频的教育类内容质量非常高，我经常在这里找到优质的教学资源。课程讲解清晰，制作精良，对我的教学工作帮助很大。',
    rating: 5,
  },
  {
    name: '李女士',
    role: '内容创作者',
    content: '作为创作者，精品视频平台给了我很好的展示机会。平台的分成机制公平透明，运营团队也非常专业，让创作者可以专注于内容创作本身。',
    rating: 5,
  },
  {
    name: '王同学',
    role: '大学生',
    content: '这里的职场技能和编程课程对我帮助太大了！通过平台的学习资源，我成功拿到了心仪的实习offer。强烈推荐给所有想要提升自己的同学。',
    rating: 5,
  },
  {
    name: '赵女士',
    role: '白领上班族',
    content: '下班后最喜欢打开精品视频放松一下，纪录片和文化类内容都特别精彩。画质清晰，界面简洁，使用体验非常好。',
    rating: 4,
  },
];

function ContactForm() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotInput = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotInput && honeypotInput.value.trim() !== '') {
      alert('提交成功！感谢您的留言，我们会尽快回复。');
      form.reset();
      return;
    }

    const formData = new FormData(form);
    const submitUrl = 'https://readdy.ai/api/form/d9rcrhfnahb7382ovkkg';
    fetch(submitUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        try {
          const data = JSON.parse(text);
          if (res.ok && data.code === 'OK') {
            alert('提交成功！感谢您的留言，我们会尽快回复。');
            form.reset();
          } else {
            const msg = data?.meta?.message || data?.message || '提交失败，请稍后再试';
            alert(msg);
          }
        } catch {
          if (res.ok) {
            alert('提交成功！感谢您的留言，我们会尽快回复。');
            form.reset();
          } else {
            alert('提交失败，请稍后再试');
          }
        }
      })
      .catch(() => {
        alert('网络错误，请稍后再试');
      });
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form="" id="about-contact-form" className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-2">
            姓名 <span className="text-accent-500">*</span>
          </label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-2">
            邮箱 <span className="text-accent-500">*</span>
          </label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            placeholder="请输入您的邮箱地址"
          />
        </div>
      </div>
      <div>
        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-2">
          主题
        </label>
        <input
          id="contact-subject"
          name="subject"
          type="text"
          className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
          placeholder="请输入留言主题"
        />
      </div>
      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-2">
          留言内容 <span className="text-accent-500">*</span>
        </label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
          placeholder="请输入您的留言内容（最多500字）"
        ></textarea>
        <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
      </div>
      <div className="hp-field-container">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
      </div>
      <button
        type="submit"
        className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
      >
        发送留言
      </button>
    </form>
  );
}

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.jingpinvideo.com' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      },
      {
        '@type': 'AboutPage',
        name: '关于精品视频',
        description: '精品视频是一个高质量视频内容平台，涵盖教育、娱乐、生活、职场等多元领域。了解我们的品牌故事、发展历程和联系方式。',
        url: 'https://www.jingpinvideo.com/about',
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: '精品视频平台的使命是什么？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '精品视频致力于打造中文世界最优质的视频内容平台，通过严格的内容筛选机制和专业的内容运营，为用户提供有价值、有品质的视频内容，同时为创作者提供公平、可持续的发展空间。',
            },
          },
          {
            '@type': 'Question',
            name: '如何成为精品视频平台的创作者？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '您可以通过平台的「创作者入驻」通道提交申请。我们的内容运营团队会在收到申请后的3个工作日内进行审核，审核通过后即可成为平台认证创作者，享受内容分成、流量扶持等多项权益。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      <Navbar />
      <div className="pt-16">
        <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />

        {/* Brand Intro */}
        <section className="w-full bg-background-50">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6 text-center">
              关于精品视频
            </h1>
            <div className="prose max-w-none">
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base">
                精品视频成立于2020年，是一个专注于高质量视频内容的聚合平台。
                我们汇聚了来自教育学习、娱乐影视、生活方式、职场技能、科技数码、音乐艺术、体育运动、原创精品等八大领域的优质视频内容，
                致力于为中文用户提供极致的视听体验。
              </p>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base mt-4">
                平台始终坚持「内容为王」的核心理念。我们的专业编辑团队对每一部上线视频进行严格审核，
                从内容价值、制作质量、信息准确性等多个维度进行把关，确保用户看到的每一帧都是精品。
              </p>
              <p className="text-foreground-700 leading-relaxed text-sm md:text-base mt-4">
                经过六年的发展，精品视频已成为中文视频内容领域的重要平台。
                截至目前，平台已汇聚超过50,000部精品视频，与3,200多位优质创作者建立合作，
                日均服务超过120万用户。我们相信，好的内容值得被更多人看到。
              </p>
            </div>
          </div>
        </section>

        {/* Brand Values */}
        <section className="w-full bg-background-100/60">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8 md:mb-10 text-center">
              品牌理念
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {brandValues.map((value) => (
                <div key={value.title} className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60 text-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-5">
                    <i className={`${value.icon} text-2xl md:text-3xl`}></i>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">{value.title}</h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">{value.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="w-full bg-background-50">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8 md:mb-10 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 -translate-x-1/2 hidden md:block"></div>
              <div className="space-y-6 md:space-y-0">
                {milestones.map((item, index) => (
                  <div
                    key={item.year}
                    className={`relative flex flex-col md:flex-row items-start gap-4 md:gap-0 ${
                      index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    } ${index !== 0 ? 'md:mt-10' : ''}`}
                  >
                    <div className={`w-full md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12 md:text-left'}`}>
                      <div className="bg-background-100 rounded-xl p-5 border border-background-200/60">
                        <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold mb-2">
                          {item.year}
                        </span>
                        <p className="text-foreground-600 text-sm leading-relaxed">{item.event}</p>
                      </div>
                    </div>
                    <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 flex items-center justify-center">
                      <div className="w-3 h-3 rounded-full bg-accent-400 border-2 border-background-50"></div>
                    </div>
                    <div className="md:w-1/2"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full bg-background-100/60">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-8 md:mb-10 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {testimonials.map((item) => (
                <div key={item.name} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">&ldquo;{item.content}&rdquo;</p>
                  <div className="flex items-center gap-3 pt-4 border-t border-background-100">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 text-sm font-bold">
                      {item.name[0]}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">{item.name}</p>
                      <p className="text-xs text-foreground-500">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full bg-background-50">
          <div className="w-full max-w-2xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2 text-center">
              联系我们
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">
              有任何问题或建议？欢迎给我们留言，我们会尽快回复
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-8">
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/60 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </div>
                <h4 className="font-heading text-sm font-bold text-foreground-800 mb-1">电子邮箱</h4>
                <p className="text-foreground-500 text-sm">service@jingpinvideo.com</p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 border border-background-200/60 text-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-phone-line text-lg"></i>
                </div>
                <h4 className="font-heading text-sm font-bold text-foreground-800 mb-1">客服热线</h4>
                <p className="text-foreground-500 text-sm">400-888-XXXX</p>
              </div>
            </div>

            <ContactForm />
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}